import NykBasicCard from 'components/NykBasicCard/NykBasicCard.vue'

export default {
    name: 'NykBanner',
    components: {
        NykBasicCard,
    },
    props: {
        message: {
            type: String,
            required: true,
        },
        backgroundColor: {
            type: String,
            default: '',
        },
        dismissible: {
            type: Boolean,
            default: false,
        },
        dismissLabel: {
            type: String,
            default: 'Luk besked',
        },
        role: {
            type: String,
            default: 'status',
        },
    },
    emits: ['dismiss'],
}